<template>
  <div class="main-paper">
    <div class="question-paper">
      <h2>保修/售后技术支持系统使用满意度调查问卷</h2>
      <p>本问卷旨在通过对使用的保修/售后技术支持系统日常操作及使用满意度等方面情况的调查，了解系统是否能够满足现有业务需求及了解系统存在的问题提供参考，请客观回答问题。</p>
      <p>问卷题目主要包括使用情况、系统功能、服务响应、实施推进等方面内容，选择题每个问题均有A、B、C、D四个选项，请从中选择一个最符合你情况的选项，多选题可多选，问答题请直接作答。</p>
      <div class="question-list">
        <span>
          <span class="nessary-star">*</span>
          您的姓名
          <input
            type="text"
            name="name"
            v-model="titleDTOObj.dealerName"
            :disabled="isSubmitted"
          />
        </span>
        <h4>
          <span class="nessary-star">*</span>1. 您的岗位是什么?
        </h4>
        <a-checkbox-group
          v-model="titleVOList[0].titleAnswer"
          @change="checkbox1"
          :disabled="isSubmitted"
        >
          <a-row>
            <a-col>
              <a-checkbox value="A">A. 索赔员</a-checkbox>
            </a-col>
            <a-col>
              <a-checkbox value="B">B. 服务大使</a-checkbox>
            </a-col>
            <a-col>
              <a-checkbox value="C">C. 诊断技术</a-checkbox>
            </a-col>
            <a-col>
              <a-checkbox value="D">D. 服务经理</a-checkbox>
            </a-col>
            <a-col>
              <a-checkbox value="E">E. 售后经理</a-checkbox>
            </a-col>
            <a-col>
              <a-checkbox value="F">F. 配件经理</a-checkbox>
            </a-col>
            <a-col>
              <a-checkbox value="G">G. 技师</a-checkbox>
            </a-col>
            <a-col>
              <a-checkbox value="H">H. 财务</a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
        <h4>
          <span class="nessary-star">*</span>2. 您经常使用的功能模块
        </h4>
        <a-checkbox-group
          v-model="titleVOList[1].titleAnswer"
          @change="checkbox2"
          :disabled="isSubmitted"
        >
          <a-row>
            <a-col>
              <a-checkbox value="A">A. 索赔</a-checkbox>
            </a-col>
            <a-col>
              <a-checkbox value="B">B. 回运</a-checkbox>
            </a-col>
            <a-col>
              <a-checkbox value="C">C. 保修报告</a-checkbox>
            </a-col>
            <a-col>
              <a-checkbox value="D">D. 技术支持报告</a-checkbox>
            </a-col>
            <a-col>
              <a-checkbox value="E">E. 索赔款管理</a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
        <h4>
          <span class="nessary-star">*</span>3. 您是否了解与您相关的保修/售后技术支持系统的所有操作功能和流程?
        </h4>
        <a-Radio-group
          v-model="titleVOList[2].titleAnswer"
          @change="selectOther"
          :disabled="isSubmitted"
        >
          <a-row>
            <a-col>
              <a-Radio value="A">A.非常清楚</a-Radio>
            </a-col>
            <a-col>
              <a-Radio value="B">B.清楚</a-Radio>
            </a-col>
            <a-col>
              <a-Radio value="C">C.了解</a-Radio>
            </a-col>
            <a-col>
              <a-Radio value="D">D.不太了解</a-Radio>
            </a-col>
          </a-row>
        </a-Radio-group>
        <!-- <h4>如选择D，跳转至第4题，如选择A、B、C则跳转至5</h4> -->
        <h4 v-if="!isSelect4">
          <span class="nessary-star">*</span>4. 上题如选D，则你认为自己不了解的原因是什么?
        </h4>
        <a-checkbox-group
          v-if="!isSelect4"
          v-model="titleVOList[3].titleAnswer"
          @change="checkbox4"
          :disabled="isSubmitted"
        >
          <a-row>
            <a-col>
              <a-checkbox value="A">A.手工操作已经可以顺利完成本职工作,使用系统是多余的</a-checkbox>
            </a-col>
            <a-col>
              <a-checkbox value="B">B.培训少或遇到问题时无法得到及时解答</a-checkbox>
            </a-col>
            <a-col>
              <a-checkbox value="C">C.系统设计有问题,操作不便或不知道应该如何操作或没有及时提醒功能或提醒方式不好造成的</a-checkbox>
            </a-col>
            <a-col>
              <a-checkbox value="D">D.自己的工作不需要使用保修/售后技术支持系统</a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
        <h4 v-if="!isSelect5">
          <span class="nessary-star">*</span>4. 保修/售后技术支持系统使用至今对你自身工作是否有改善?
        </h4>
        <a-Radio-group
          v-if="!isSelect5"
          v-model="titleVOList[4].titleAnswer"
          :disabled="isSubmitted"
        >
          <a-row>
            <a-col>
              <a-Radio value="A">A.有非常明显的改善</a-Radio>
            </a-col>
            <a-col>
              <a-Radio value="B">B.有一定改善，经销商操作管理更加规范，工作量减少</a-Radio>
            </a-col>
            <a-col>
              <a-Radio value="C">C.没有明显改善</a-Radio>
            </a-col>
            <a-col>
              <a-Radio value="D">D.有一定的退步，感觉工作量反而所增加</a-Radio>
            </a-col>
          </a-row>
        </a-Radio-group>
        <h4>
          <span v-if="!isSelectD" class="nessary-star">*</span>5. 你认为保修/售后技术支持系统的操作性如何?
        </h4>
        <a-Radio-group v-model="titleVOList[5].titleAnswer" :disabled="isSelectD || isSubmitted">
          <a-row>
            <a-col>
              <a-Radio value="A">A.非常好。界面整齐，操作非常便利</a-Radio>
            </a-col>
            <a-col>
              <a-Radio value="B">B.很好。界面整齐，操作很便利</a-Radio>
            </a-col>
            <a-col>
              <a-Radio value="C">C.一般。界面一般，操作一般</a-Radio>
            </a-col>
            <a-col>
              <a-Radio value="D">D.很差。惨不忍睹，操作很不方便</a-Radio>
            </a-col>
          </a-row>
        </a-Radio-group>
        <h4>
          <span v-if="!isSelectD" class="nessary-star">*</span>6. 你认为保修/售后技术支持系统对于您而言，系统设计的操作流程及功能模块是否合理?
        </h4>
        <a-Radio-group v-model="titleVOList[6].titleAnswer" :disabled="isSelectD || isSubmitted">
          <a-row>
            <a-col>
              <a-Radio value="A">A. 非常合理。优化和规范了操作流程；涵盖了业务的各方面,功能齐全且合理</a-Radio>
            </a-col>
            <a-col>
              <a-Radio value="B">B. 很合理。对工作有促进和改善作用，功能上包括了大多数的工作内容</a-Radio>
            </a-col>
            <a-col>
              <a-Radio value="C">C. 一般。流程上有些地方有改善，有些地方反而更加繁琐；功能基本能满足日常使用，但还是感觉缺少点什么</a-Radio>
            </a-col>
            <a-col>
              <a-Radio value="D">D. 不太合理。流程改善的地方乏善可陈。增加的工作量无效且繁琐；有的功能不全，有的虽然很全但不合理</a-Radio>
            </a-col>
          </a-row>
        </a-Radio-group>
        <h4>
          <span v-if="!isSelectD" class="nessary-star">*</span>7. 总体而言，你认为现有保修/售后技术支持系统是否能满足您工作的需要?
        </h4>
        <a-Radio-group v-model="titleVOList[7].titleAnswer" :disabled="isSelectD || isSubmitted">
          <a-row>
            <a-col>
              <a-Radio value="A">A.完全满足。基本上不再需要什么修改,已经可以满足要求</a-Radio>
            </a-col>
            <a-col>
              <a-Radio value="B">B. 满足。大多数功能符合要求,需要改进的地方也不太多</a-Radio>
            </a-col>
            <a-col>
              <a-Radio value="C">C. 基本满足。功能基本符合要求。但在某些方面还需要改进</a-Radio>
            </a-col>
            <a-col>
              <a-Radio value="D">D. 不太满足。功能基本上都不能符合要求</a-Radio>
            </a-col>
          </a-row>
        </a-Radio-group>
        <h4>
          <span v-if="!isSelectD" class="nessary-star">*</span>8. 如果不使用保修/售后技术支持系统，会给你的工作带来怎样的影响?
        </h4>
        <a-Radio-group v-model="titleVOList[8].titleAnswer" :disabled="isSelectD || isSubmitted">
          <a-row>
            <a-col>
              <a-Radio value="A">A. 无法正常工作</a-Radio>
            </a-col>
            <a-col>
              <a-Radio value="B">B. 部分工作无法进行，影响正常工作</a-Radio>
            </a-col>
            <a-col>
              <a-Radio value="C">C. 有一定影响，一段时间内会不太习惯</a-Radio>
            </a-col>
            <a-col>
              <a-Radio value="D">D. 没有明显影响，其他方式可以解决问题</a-Radio>
            </a-col>
          </a-row>
        </a-Radio-group>
        <h4>
          <span v-if="!isSelectD" class="nessary-star">*</span>9.你对到目前为止保修/售后技术支持系统的整体评价如何（100分为满分）?
        </h4>
        <a-input placeholder="请输入分数" v-model="titleVOList[9].titleAnswer" :disabled="isSelectD || isSubmitted" />
        <h4>10.保修/售后技术支持系统还有什么问题或还有哪些需求是您所需要的（字数不限）</h4>
        <a-textarea v-model="titleVOList[10].titleAnswer" :rows="4" :disabled="isSubmitted" />
        <br />
        <div class="submit-button">
          <a-button @click="againSubmit" v-if="isSubmitted" type="primary">再次填写问卷</a-button>
          <a-button @click="finish" v-else type="primary">确认提交</a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  Checkbox,
  Col,
  Row,
  Radio,
  Input,
  Button,
  message,
  InputNumber,
} from "ant-design-vue";
import Vue from "vue";
Vue.use(Checkbox);
Vue.use(Col);
Vue.use(Row);
Vue.use(Radio);
Vue.use(Input);
Vue.use(Button);
Vue.use(InputNumber);

export default {
  data() {
    return {
      obj: {},
      test: {},
      // number: "",
      isSelect4: true,
      isSelect5: false,
      isSelectD: false,
      // isSubmitted: true,
      checkoutD: "-1",
      // dealerName: "",
      titleDTOList: [],
      titleVOList: [
        {
          titleNumber: 1,
          titleAnswer: [],
        },
        {
          titleNumber: 2,
          titleAnswer: [],
        },
        {
          titleNumber: 3,
          titleAnswer: "",
        },
        {
          titleNumber: 4,
          titleAnswer: [],
        },
        {
          titleNumber: 5,
          titleAnswer: "",
        },
        {
          titleNumber: 6,
          titleAnswer: "",
        },
        {
          titleNumber: 7,
          titleAnswer: "",
        },
        {
          titleNumber: 8,
          titleAnswer: "",
        },
        {
          titleNumber: 9,
          titleAnswer: "",
        },
        {
          titleNumber: 10,
          titleAnswer: "",
        },
        {
          titleNumber: 11,
          titleAnswer: "",
        },
      ],
    };
  },
  mounted() {
    let dealerId = JSON.parse(localStorage.getItem("pro__userInfo")).value.id;
    this.$store.dispatch("searchHistoryPosition", { id: dealerId });
  },
  methods: {
    checkbox1(checkedValues) {
      this.titleVOList[0].titleAnswer = checkedValues;
    },
    checkbox2(checkedValues) {
      this.titleVOList[1].titleAnswer = checkedValues;
    },
    checkbox4(checkedValues) {
      this.titleVOList[3].titleAnswer = checkedValues;
      this.checkoutD = checkedValues.indexOf("D");
      // -1没选
      if (this.checkoutD == "-1") {
        console.log("没选");
        this.isSelectD = false;
      } else {
        console.log("xuanle");
        this.isSelectD = true;
      }
    },
    finish() {
      // 接口数据处理
      // let para = {
      //   dealerId: JSON.parse(localStorage.getItem("pro__userInfo")).value.id,
      //   dealerName: this.dealerName,
      //   titleVOList: this.titleVOList,
      // };
      this.titleDTOObj.dealerId = JSON.parse(
        localStorage.getItem("pro__userInfo")
      ).value.id;
      // this.titleDTOObj.titleDTOList = this.titleVOList;
      this.titleDTOObj.titleDTOList = JSON.parse(
        JSON.stringify(this.titleVOList)
      );
      console.log(this.titleDTOObj.titleDTOList);
      this.titleDTOObj.titleVOList = [];
      this.titleDTOObj.titleDTOList[0].titleAnswer = this.titleVOList[0].titleAnswer.toString();
      this.titleDTOObj.titleDTOList[1].titleAnswer = this.titleVOList[1].titleAnswer.toString();
      this.titleDTOObj.titleDTOList[3].titleAnswer = this.titleVOList[3].titleAnswer.toString();
      var r = new RegExp("^([1-9]|[1-9]\\d|100)$");
      if (!this.titleDTOObj.dealerName) {
        message.warning("请填写您的姓名");
        return;
      } else if (!this.titleVOList[0].titleAnswer) {
        message.warning("请填写第1题");
        return;
      } else if (!this.titleVOList[1].titleAnswer) {
        message.warning("请填写第2题");
        return;
      } else if (!this.titleVOList[2].titleAnswer) {
        message.warning("请填写第3题");
        return;
      } else if (
        !this.titleVOList[3].titleAnswer &&
        !this.titleVOList[4].titleAnswer
      ) {
        message.warning("请填写第4题");
        return;
        // 选了D
      } else if (this.isSelectD) {
        this.titleDTOObj.effectiveFlag = "0";
        this.$store.dispatch("submitQuestion", this.titleDTOObj);
        return;
      } else if (!this.titleVOList[5].titleAnswer) {
        message.warning("请填写第5题");
        return;
      } else if (!this.titleVOList[6].titleAnswer) {
        message.warning("请填写第6题");
        return;
      } else if (!this.titleVOList[7].titleAnswer) {
        message.warning("请填写第7题");
        return;
      } else if (!this.titleVOList[8].titleAnswer) {
        message.warning("请填写第8题");
        return;
      } else if (!this.titleVOList[9].titleAnswer) {
        message.warning("请填写第9题");
        return;
      } else if (!r.test(this.titleVOList[9].titleAnswer)) {
        message.warning("系统整体评分只能输入1-100的整数");
        return;
      } else {
        this.$store.dispatch("submitQuestion", this.titleDTOObj);
      }
    },
    selectOther() {
      if (this.titleVOList[2].titleAnswer == "D") {
        this.isSelect5 = true;
        this.titleVOList[4].titleAnswer = "";
        // 4
        this.isSelect4 = false;
      } else if (
        this.titleVOList[2].titleAnswer == "A" ||
        this.titleVOList[2].titleAnswer == "B" ||
        this.titleVOList[2].titleAnswer == "C"
      ) {
        this.isSelect4 = true;
        this.titleVOList[3].titleAnswer = [];
        this.isSelect5 = false;
        this.isSelectD = false;
      }
    },
    // 再次填写问卷
    againSubmit() {
      this.$store.commit("CHANGE_SUBMIT");
      // this.number = ""
      this.titleDTOObj.dealerId = "";
      this.titleDTOObj.dealerName = "";
      this.titleDTOObj.effectiveFlag = "";
      this.titleDTOObj.id = "";
      this.titleVOList = [
        {
          titleNumber: 1,
          titleAnswer: [],
        },
        {
          titleNumber: 2,
          titleAnswer: [],
        },
        {
          titleNumber: 3,
          titleAnswer: "",
        },
        {
          titleNumber: 4,
          titleAnswer: [],
        },
        {
          titleNumber: 5,
          titleAnswer: "",
        },
        {
          titleNumber: 6,
          titleAnswer: "",
        },
        {
          titleNumber: 7,
          titleAnswer: "",
        },
        {
          titleNumber: 8,
          titleAnswer: "",
        },
        {
          titleNumber: 9,
          titleAnswer: "",
        },
        {
          titleNumber: 10,
          titleAnswer: "",
        },
        {
          titleNumber: 11,
          titleAnswer: "",
        },
      ];
    },
  },
  computed: {
    ...mapState({
      isSubmitted: (state) => state.utils.isSubmitted,
      titleDTOObj: (state) => state.utils.titleDTOObj,
    }),
  },
  watch: {
    // number(newName, oldName) {
    //   var r = new RegExp("^([1-9]|[1-9]\\d|100)$"); //0-100的正整数
    //   if (!r.test(newName)) {
    //     alert("保修/售后技术支持系统整体评分只能输入1-100的整数");
    //   } else {
    //     this.titleVOList[9].titleAnswer = newName;
    //   }
    // },
    titleDTOObj(val) {
      if (val) {
        this.titleVOList = val.titleVOList;
        // this.number = val.titleVOList[9].titleAnswer;
        // 变数组
        if (this.titleVOList[3].titleAnswer !== "") {
          this.titleVOList[3].titleAnswer = this.titleVOList[3].titleAnswer.split(
            ","
          );
        } else {
          this.titleVOList[3].titleAnswer = [];
        }
        if (this.titleVOList[0].titleAnswer !== "") {
          this.titleVOList[0].titleAnswer = this.titleVOList[0].titleAnswer.split(
            ","
          );
        } else {
          this.titleVOList[0].titleAnswer = [];
        }
        if (this.titleVOList[1].titleAnswer !== "") {
          this.titleVOList[1].titleAnswer = this.titleVOList[1].titleAnswer.split(
            ","
          );
        } else {
          this.titleVOList[1].titleAnswer = [];
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.main-paper {
  width: 100%;
  height: 100%;
  padding: 50px 100px;
  background: url("../assets/images/question_bg.png");
  background-size: cover;
  // margin-left: 20px;
  overflow: scroll;
  h2 {
    text-align: center;
  }
  p {
    text-indent: 2em;
    margin-top: 15px;
  }
  .question-list {
    h4 {
      margin-top: 15px;
    }
    .submit-button {
      text-align: center;
      button {
        margin-top: 50px;
        margin-bottom: 20px;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
      }
    }
  }
}
.ant-input-number {
  width: 100%;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.ant-input-number-handler-wrap {
  display: none !important;
  width: 0;
}
</style>